// @core/api/endpoints/userprofile/list_userprofile_ban_history.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListUserprofileBanHistoryResponse,
} from '../../../types/userprofile';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/userprofile';

/**
 * List ban history for profile
 * Returns the complete ban history for a profile including all past bans, their reasons, durations, and which admin issued them.
 */
export async function ListUserprofileBanHistory(
  profile_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListUserprofileBanHistoryResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:profile_id/ban-history`;
  requestPath = requestPath.replace(':profile_id', encodeURIComponent(profile_id));
  const requestOptions = options;
  return client.get<ListUserprofileBanHistoryResponse>(requestPath, { ...requestOptions, params });
}
